export enum SubmissionPermissionTypeEnum {
  View = 1,
  Process = 2,
  Approve = 3,
  ApproveOwn = 4,
  Override = 5,
  Create = 6
}
